export interface SerializableOrgGroup {
    orgId: string
    orgGroupId: string
    locked?: boolean
    label?: string
}

export const serializeOrgGroup = (
    serializable: SerializableOrgGroup
): string => {
    return JSON.stringify([
        serializable.orgId,
        serializable.orgGroupId,
        serializable.locked ?? false,
    ])
}

export const buildSerializableOrgGroupLabel = (
    orgName?: string,
    orgGroupName?: string,
    orgAgencyName?: string
): string => {
    if (!orgName || !orgGroupName) {
        return 'Loading...'
    }
    const orgAgency = orgAgencyName ? ` | ${orgAgencyName}` : ''
    return `${orgName}${orgAgency} | ${orgGroupName}`
}
